import React from 'react';
import { t } from '../multi-language/multi-lang.service';
function Watermark() {
    return (React.createElement("div", { className: 'watermark-wrap' },
        React.createElement("div", { className: "watermark" },
            React.createElement("p", null, t('whatermark.demo')),
            React.createElement("p", null, t('whatermark.not_clinic')))));
}
export default Watermark;
//# sourceMappingURL=watermark.js.map